import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../_utils/select-wrapper';
import OptionAccordion from './option-accordion';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  selectedDeliveryOption,
  availableDeliveryOptionsForFinish,
} from '../common/finish-and-delivery-options';

const handleDeliveryChange = (value, deliveryOptions, onChange) => {
  onChange({
    delivery_option: selectedDeliveryOption(deliveryOptions, value),
  });
};

const DeliverySelector = ({
  deliveryOptions,
  deliveryOption,
  finishesByDeliveryOption,
  finish,
  onChange,
  newPrintsBuilderDeliveryAndFinishIcons,
}) => {
  const rawOptions = availableDeliveryOptionsForFinish(
    deliveryOptions,
    finishesByDeliveryOption,
    finish,
    true,
  );

  if (newPrintsBuilderDeliveryAndFinishIcons) {
    const mappedOptions = rawOptions.map((opt) => {
      const fullOpt = deliveryOptions.find(
        (d) => String(d.key) === String(opt.value),
      );
      return {
        ...opt,
        iconClass: fullOpt
          ? `delivery-options__horizontal__${fullOpt.type.toLowerCase()}`
          : '',
      };
    });

    return (
      <OptionAccordion
        title="Delivery Method"
        options={mappedOptions}
        value={deliveryOption.key}
        onChange={(value) =>
          handleDeliveryChange(value, deliveryOptions, onChange)
        }
      />
    );
  };

  return (
    <Select
      label="Delivery Method"
      aria-label="Select Delivery"
      value={deliveryOption.key}
      options={rawOptions}
      inputStyleLink
      withCaret
      onChange={(value) =>
        handleDeliveryChange(value, deliveryOptions, onChange)
      }
    />
  );
};

DeliverySelector.propTypes = {
  deliveryOptions: PropTypes.arrayOf(DeliveryOption),
  deliveryOption: DeliveryOption,
  finishesByDeliveryOption: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish,
  onChange: PropTypes.func,
  newPrintsBuilderDeliveryAndFinishIcons: PropTypes.bool,
}.isRequired;

export default DeliverySelector;
